<script>
    import shortid from "shortid";
    import { getResourceData } from "shared/resource";
    import { getIbeHost } from 'shared/Utilities/fetchUtilities';
    import { getDisclaimerSections } from "shared/Utilities/disclaimerUtilities";
    import f9select from "inputs/f9select.vue";
    import f9date from "inputs/f9date.vue";
    import f9phone from "inputs/f9phone.vue";
    import f9input from 'inputs/f9input.vue';
    import f9field from 'inputs/f9field.vue';
    import frontierLegal from 'shared/Components/sections/frontierLegal.vue';

    export default {
        props: {
            "value": Object,
            "showTerms": {
                type: Boolean,
                default: true
            },
            "disabled": Boolean,
            "saved": Boolean,
            "validationScope": {
                type: String,
                default: "signup-fields"
            },
            "isDDSignup": {
                type: Boolean,
                default: false
            },
            "isWPSignup": {
                type: Boolean,
                default: false
            },
            "isUSOnlySignup": {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                id: shortid.generate(),
                imageRelativePath: "/Content/responsive/images/",
                changed: true,
                host: "",
                resourceData: {},
                email: "",
                confirmEmail: "",
                password: "",
                confirmPassword: "",
                firstName: "",
                middleName: "",
                lastName: "",
                suffix: "",
                gender: "",
                birthDate: null,
                country: "",
                address: "",
                address2: "",
                zipCode: "",
                city: "",
                state: "",
                phone: "",
                title: ""
            }
        },
        computed: {
            emailValidation() {
                return 'required|email' + (!this.disabled ? '|existing_email:' + this.host : "");
            },
            hideStateZipFields() {
                return this.country !== "US" && this.country !== "" ? false : true;
            },
            disclaimerSection() {
                const disclaimerSections = getDisclaimerSections();

                if (this.isDDSignup) {
                    return disclaimerSections.find(section => section.id == "DiscountDen");
                }
                else if (this.isWPSignup) {
                    return disclaimerSections.find(section => section.id == "GoWild");
                }
                return disclaimerSections.find(section => section.id == "FrontierMiles");
            }
        },
        components: {
            f9select,
            f9date,
            f9phone,
            f9input,
            f9field,
            frontierLegal
        },
        mounted() {
            Object.assign(this, this.value);

            this.$nextTick(() => {
                this.host = getIbeHost();
                const params = `?usOnly=${this.isUSOnlySignup}`;

                getResourceData(true, this.host, params).then(x => {
                    this.resourceData = x;
                })
            });
        },
        methods: {
            changeValue() {
                this.changed = true;

                this.$emit('input', {
                    email: this.email,
                    confirmEmail: this.confirmEmail,
                    password: this.password,
                    confirmPassword: this.confirmPassword,
                    firstName: this.firstName,
                    middleName: this.middleName,
                    lastName: this.lastName,
                    suffix: this.suffix,
                    gender: this.gender,
                    birthDate: this.birthDate,
                    country: this.country,
                    address: this.address,
                    address2: this.address2,
                    zipCode: this.zipCode,
                    city: this.city,
                    state: this.state,
                    phone: this.phone,
                    title: this.title
                });

                this.$emit('change');
            },
            loadValue(customer) {
                this.email = customer.email,
                this.confirmEmail = customer.confirmEmail,
                this.password = customer.password,
                this.confirmPassword = customer.confirmPassword,
                this.firstName = customer.firstName,
                this.middleName = customer.middleName,
                this.lastName = customer.lastName,
                this.suffix = customer.suffix,
                this.gender = customer.gender,
                this.birthDate = customer.birthDate,
                this.country = customer.country,
                this.address = customer.address,
                this.address2 = customer.address2,
                this.zipCode = customer.zipCode,
                this.city = customer.city,
                this.state = customer.state,
                this.phone = customer.phone,
                this.title = customer.title
            },
            validateSignupFieldsConsistency() {
                return this.validateConfirmFields() && this.validateAddress();
            },
            validateConfirmFields() {
                const confirmEmail = this.confirmFields('confirm_email', 'email'),
                    confirmPassword = this.confirmFields('confirm_password', 'password')

                return confirmEmail && confirmPassword;
            },
            validateAddress() {
                return this.checkInequality('address1', 'city');
            }
        },
        watch: {
            saved(val) {
                if (val) {
                    this.changed = false;
                }
            },
            country(val, oldVal) {
                if (oldVal) {
                    this.address = this.address2 = this.city = this.state = this.zipCode = "";
                }
            }
        },
        inject: ["$validator"]
    }
</script>

<template>
    
    <div class="signup-fields" @change="changeValue">
        
        <div class="signup-title">
            <div class="signup-title-box">
                <div class="text-large">MEMBER INFO </div>
            </div>
        </div>

        <!-- Email Address -->
        <f9field label="Email Address*">
            <f9input autocomplete="off" :saved="!changed" v-model="email" type="text" v-validate="emailValidation" maxlength="256" ref="email" name="email"
                     :disabled="disabled" :data-vv-scope="validationScope"></f9input>
        </f9field>

        <!-- Confirm Email Address -->
        <f9field label="Confirm Email Address*">
            <f9input autocomplete="off" :saved="!changed" v-model="confirmEmail" @change="confirmFields('confirm_email', 'email')" type="text" v-validate="'required'"
                     maxlength="256" ref="confirm_email" name="confirm_email" :disabled="disabled" :data-vv-scope="validationScope"></f9input>
        </f9field>

        <!-- Password -->
        <div class="signup-password-container">
            <div class="signup-password">
                <!-- Password -->
                <f9field label="Password*">
                    <f9input :saved="!changed" v-model="password" autocomplete="off" type="password" v-validate="'required|password'" ref="password"
                             name="password" :disabled="disabled" :data-vv-scope="validationScope"></f9input>
                </f9field>

                <!-- Confirm Password -->
                <f9field label="Confirm Password*">
                    <f9input :saved="!changed" v-model="confirmPassword" type="password" @change="confirmFields('confirm_password', 'password')"
                             ref="confirm_password" name="confirm_password" v-validate="'required'" :disabled="disabled" :data-vv-scope="validationScope"></f9input>
                </f9field>
            </div>
            <div class="signup-password-requirements">
                <span>
                    <b>Password Requirements:</b>
                    <ul>
                        <li>8-16 characters</li>
                        <li>At least one upper & lowercase letter</li>
                        <li>At least one number</li>
                        <li>One special character</li>
                        <li>No "." "," "~" or "_"</li>
                    </ul>
                </span>
            </div>
        </div>

        <div class="hr"></div>

        <!-- CONTACT INFO -->
        <div class="signup-title">
            <div class="signup-title-box">
                <div class="text-large">CONTACT INFO</div>
            </div>
        </div>

        <!-- First Name -->
        <f9field label="First Name*">
            <f9input :saved="!changed" v-model="firstName" type="text" v-validate="'required|max:30|alpha_spaces'" maxlength="30" name="first_name"
                     :disabled="disabled" :data-vv-scope="validationScope"></f9input>
        </f9field>

        <!-- Middle Name -->
        <f9field label="Middle Name">
            <f9input :saved="!changed" v-model="middleName" type="text" v-validate="'alpha|max:30'" maxlength="30" name="middle_name"
                     :disabled="disabled" :data-vv-scope="validationScope"></f9input>
        </f9field>

        <!-- Last Name + Suffix -->
        <div class="slider-form-row">
            <f9field label="Last Name*">
                <f9input :saved="!changed" v-model="lastName" type="text" v-validate="'required|alpha_spaces|max:30'" maxlength="30"
                         name="last_name" :disabled="disabled" :data-vv-scope="validationScope"></f9input>
            </f9field>

            <f9field label="Suffix" half>
                <f9select :saved="!changed" v-model="suffix" :disabled="disabled" name="suffix">
                    <option value="" selected="selected"></option>
                    <option value="JR">Jr.</option>
                    <option value="SR">Sr.</option>
                    <option value="I">FIRST</option>
                    <option value="II">SECOND</option>
                    <option value="III">THIRD</option>
                </f9select>
            </f9field>
        </div>

        <!-- Gender + DOB -->
        <div class="slider-form-row">
            <f9field label="Gender*" half>
                <f9select :saved="!changed" v-model="gender" v-validate="'required'" :data-vv-scope="validationScope" name="gender" :disabled="disabled">
                    <option value="" selected="selected"></option>
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                </f9select>
            </f9field>

            <f9field label="Date of Birth*" half>
                <f9date :saved="!changed" v-model="birthDate" name="birth_date" :disabled="disabled" :data-vv-scope="validationScope" format = "MM/DD/YYYY"
                    v-validate="{ required: true, date_format: 'MM/DD/YYYY', date_between: { min: '01/01/1900', max: new Date()} }">
                </f9date>
            </f9field>
        </div>

        <!-- Phone Number -->
        <f9field label="Phone Number*">
            <f9phone :saved="!changed" v-model="phone" v-validate="'required|phone'" :data-vv-scope="validationScope" name="phone" :disabled="disabled" />
        </f9field>

        <!-- Country -->
        <f9field label="Country*">
            <f9select :saved="!changed" v-model="country" v-validate="'required'" :data-vv-scope="validationScope" name="country" :disabled="disabled">
                <option value="" selected="selected"></option>
                <option v-for="country in resourceData.countries" :key="country.code" :value="country.code">{{ country.name }}</option>
            </f9select>
        </f9field>

        <!-- Address + Address 2 -->
        <div class="slider-form-row">
            <f9field label="Address 1*">
                <f9input :saved="!changed" v-model="address" type="text" v-validate="'required|address|max:256'" :data-vv-scope="validationScope"
                         maxlength="256" ref="address1" name="address1" :disabled="disabled"></f9input>
            </f9field>

            <f9field label="Address 2">
                <f9input :saved="!changed" v-model="address2" type="text" v-validate="'address|max:256'" :data-vv-scope="validationScope" 
                         maxlength="256" name="address2" :disabled="disabled"></f9input>
            </f9field>
        </div>

        <!-- City -->
        <f9field label="City*">
            <f9input :saved="!changed" v-model="city" type="text" v-validate="'required|max:256'" :data-vv-scope="validationScope" 
                     maxlength="256" ref="city" name="city" :disabled="disabled"></f9input>
        </f9field>

        <!-- State & Zip -->
        <div class="slider-form-row state-zip" v-if="hideStateZipFields">
            <f9field half label="State*">
                <f9select :saved="!changed" v-model="state" v-validate="'required'" :data-vv-scope="validationScope" name="state" :disabled="disabled">
                    <option value="" selected="selected"></option>
                    <option v-for="state in resourceData.usStates" :key="state.code" :value="state.code">{{ state.name }}</option>
                </f9select>
            </f9field>

            <f9field half label="Zip Code*">
                <f9input :saved="!changed" v-model="zipCode" type="text" v-validate="'required|zip_code'" :data-vv-scope="validationScope" maxlength="12" name="zip_code"
                         :disabled="disabled"></f9input>
            </f9field>
        </div>

        <!-- Terms and Conditions -->
        <div class="signup-terms" v-if="showTerms">
            <span>By clicking "Join Now" you confirm that:</span>
            <ul class="signup-terms-bullet">
                <frontierLegal :disclaimer-section="disclaimerSection" />
            </ul>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";
    @import "~less-mixins";

    ul {
        padding-left: 16px;
    }
    
    .signup-fields {
        padding: 17px 24px 0;
        border-style: solid;
        border-width: 1px;
        border-color: hsla(0, 0%, 43%, .25);
        box-sizing: border-box;

        .hr {
            border-bottom: 1px solid @frontier-gray-xxlighter;
            margin-top: 8px;
            margin-bottom: 20px;
        }

        .signup-password-container {
            display: flex;
            justify-content: flex-start;
        
            .signup-password-requirements {
                display: flex;
                align-items: center;
                padding: 26px 22px 22px 33px;
                max-height: 113px;
                margin-top: 19px;
                margin-left: 48px;
                color: #6d6d6d;
                font-size: 14px;
                line-height: 18px;
                position: relative;

                &::before {
                    .background-opacity()
                }
            }

        }

        .signup-legend {
            text-align: right;
            margin-top: 10px;
            margin-bottom: 5px;
        }

        .signup-title {
            margin-top: 10px;
            margin-bottom: 14px;
            display: flex;
            align-items: center;

            .signup-title-box {
                display: flex;
                align-items: center;
                white-space: nowrap;
                margin-right: 40px;

                img {
                    padding-right: 3px;
                    max-width: initial;
                }
            }
        }

        .slider-label {
            font-size: 11px;
            padding-bottom: 6px;
        }

        .slider-field, .slider-form-row {
            justify-content: flex-start;
        }
        
		.state-zip {
            padding-bottom: 24px;
        }

        .slider-field-margin-left {
            padding-left: 0;
            margin-left: 14px;
        }
        
        .text-large {
            color: @frontier-green;
            font-size: 22px;
            font-weight: 600;
        }
        
        .signup-terms {
            color: @ibe-text--gray;
            font-size: 12px;
            line-height: 140%;
            font-weight: 400;
            margin: 8px 0;

            a {
                color: @frontier-green;
                text-decoration: underline;
            }

            .signup-terms-bullet {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                line-height: 20px;
                padding: 12px 0 0 40px;
                margin: 0;
            }
        }
    }

    @media @tablet {
        .signup-fields {
            padding: 17px 14px 0;

            .signup-title {
                margin-bottom: 7px;
                margin-top: 0;
            }

            .slider-form-row,
            .slider-field {
                padding-bottom: 0px;
            }

            .hr {
                margin-top: 20px;
            }

            .slider-form-row {
                margin-bottom: 14px;
            }

            .state-zip {
                padding-bottom: 0;
                margin-bottom: 0;
            }

            .slider-label {
                font-size: 11px;
            }

            .slider-field input {
                margin-bottom: 14px;
            }

            .text-large {
                font-size: 16px;
            }

            .signup-password-container {
                display: block;
                
                .signup-password-requirements {
                    background-color: #e8e8e8;
                    padding: 9px 13px;
                    min-height: 75px;
                    max-width: 100%;
                    margin-top: 13px;
                    margin-left: 0px;
                    color: #6d6d6d;
                    font-size: 11px;
                    line-height: 14px;
                    font-weight: 400;
                    text-align: left;
                }
            }
        }
    }
</style>

